import { finalizeCurityLogin } from 'src/services/session/curityLogin';
import { getSession, onSessionChange, setSession } from 'src/services/session/store';

import { getEnvironment, getProdEnvironment } from 'src/lib/featureFlags';
import { localStorage } from 'src/lib/localStorage';

import {
  error,
  loggedIn,
  loggedOut,
  restoredLoggedIn,
  restoredLoggedOut,
} from './actions';

const loginResultWindow = () => window.location.pathname === '/integration-jira-ui/oauth/callback';

const stateMatch = () => {
  const params = window.location.hash.slice(1);
  const searchParams = new URLSearchParams(params);
  const state = searchParams.get('state');

  return state === localStorage.getItem('integration_jira_oauth_state');
};

const credentialsFromUrl = () => {
  const params = window.location.hash.slice(1);
  const searchParams = new URLSearchParams(params);

  const accessToken = searchParams.get('access_token');
  const accountDomain = searchParams.get('subdomain');

  if (accessToken && accountDomain) {
    const {
      appBaseUrl,
      apiBaseUrl,
      accountBaseUrlTemplate
    } = getEnvironment();
    const accountBaseUrl = accountBaseUrlTemplate.replace('{domain}', accountDomain);

    return {
      accessToken,
      accountDomain,
      environment: {
        accountBaseUrl,
        apiBaseUrl,
        appBaseUrl
      }
    };
  }
  return null;
};

const errorFromUrl = () => {
  const params = window.location.hash.slice(1);
  const searchParams = new URLSearchParams(params);

  const accessToken = searchParams.get('access_token');
  const accountDomain = searchParams.get('subdomain');
  const error =
       searchParams.get('error_description')
    || searchParams.get('error')
    || 'Server did not return any login results';

  if (!accessToken || !accountDomain) {
    return { error: ['Failed to login', error] };
  }
  return null;
};

const credentialsFromLocalStorage = () => {
  let { accountDomain, accessToken, environment } = getSession() || {};
  if (!accountDomain || !accessToken) return null;
  const {
    appBaseUrl,
    apiBaseUrl,
    accountBaseUrlTemplate
  } = getProdEnvironment();
  const accountBaseUrl = accountBaseUrlTemplate.replace('{domain}', accountDomain);
  environment = {
    apiBaseUrl,
    appBaseUrl,
    accountBaseUrl,
    ...environment
  };
  return {
    accountDomain,
    accessToken,
    environment
  };
};

const finalizeWebLegacyLogin = (store) => {
  if (stateMatch()) {
    localStorage.setItem('integration_jira_oauth_state', undefined);
  } else {
    store.dispatch(error({ error: {
      title: 'We’re having trouble connecting to your account',
      body: `Please make sure your browser is configured to allow third-party cookies.${
        localStorage.getItem('integration_jira_oauth_state') === null
          ? ' In Safari browser try disabling Preferences > Privacy > Prevent cross-site tracking'
          : ''
      }`
    } }));
    return;
  }
  if (credentialsFromUrl()) {
    store.dispatch(loggedIn(credentialsFromUrl()));
    setSession(credentialsFromUrl(), { clientKey: localStorage.getItem('integration_jira_oauth_current_client') });
    localStorage.setItem('integration_jira_oauth_current_client', undefined);
  } else {
    store.dispatch(error(errorFromUrl()));
  }
};

const middleware = store => next => action => {
  const result = next(action);

  switch (action.type) {
    case 'APP_INIT':
      if (loginResultWindow()) {
        if (getEnvironment().curityLogin) {
          finalizeCurityLogin(store);
        } else {
          finalizeWebLegacyLogin(store);
        }
      } else {
        if (credentialsFromLocalStorage()) {
          store.dispatch(restoredLoggedIn(credentialsFromLocalStorage()));
        } else {
          store.dispatch(restoredLoggedOut());
        }
        onSessionChange(val => {
          if (val) {
            store.dispatch(loggedIn(val));
          } else {
            store.dispatch(loggedOut());
          }
        });
      }
      break;
    default:
      break;
  }

  return result;
};

export default middleware;
